import React from 'react';
import moment from 'moment';
import { formatCurrency } from 'utils/functions';
import PaymentStatusTag from 'components/base/payment-status-tag';
import { ENUM_PAYMENT_STATUS } from 'models/common.model';
import { PaymentRequestDetailType } from 'models/payment-tracker.model';

export type TransactionStatusType = 'completed' | 'outstanding';

interface TransactionHistoryProps {
  paymentDetail: PaymentRequestDetailType | null;
}

const TransactionHistory: React.FC<TransactionHistoryProps> = ({ paymentDetail }) => {
  const paymentDetailData = () => {
    if (!paymentDetail) return [];

    const data = [
      {
        label: 'Vendor Name',
        value: paymentDetail.vendor.name
      },
      {
        label: 'Ingredient Name',
        value: paymentDetail.request_item.ingredient.name
      },
      {
        label: 'Quantity Requested',
        value: `${paymentDetail.request_item.quantity} ${paymentDetail.request_item.ingredient.unit_type}`
      },
      {
        label: 'Quantity Received',
        value: `${paymentDetail.request_item.quantity_received} ${paymentDetail.request_item.ingredient.unit_type}`
      },
      {
        label: 'Price Per Unit',
        value: formatCurrency(paymentDetail.request_item.price)
      },
      {
        label: 'Total Amount',
        value: formatCurrency(paymentDetail.amount)
      },
      {
        label: 'Delivery Date',
        value: moment(paymentDetail.request_item.created_at).format('Do MMM, YYYY')
      },
      {
        label: 'Payment Due Date',
        value: moment(paymentDetail.payment_due_date).format('Do MMM, YYYY')
      },
      {
        label: 'Payment Status',
        value: <PaymentStatusTag status={paymentDetail.status as ENUM_PAYMENT_STATUS} />
      },
      {
        label: 'Request Code',
        value: `#${paymentDetail.code}`
      }
    ];
    return data;
  };

  return (
    <div className='bg-[#F7F7F8] w-full h-[100%] p-1 rounded-md '>
      <div className='bg-white w-full rounded-t-md pt-4 py-3 flex items-center justify-between mb-1 px-6'>
        <label className='text-base md:text-lg font-medium'>Request details</label>
      </div>

      <div className='mt-6'>
        {!paymentDetail ? (
          <div className='text-xl leading-[40vh] text-center'>No Payment Details Found</div>
        ) : (
          <div className='bg-white rounded-md p-6'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              {paymentDetailData().map((item, index) => (
                <div key={index}>
                  <p className='text-sm text-gray-500 font-semibold mb-1'>{item.label}</p>
                  {typeof item.value === 'string' ? (
                    <p className='text-base font-medium text-gray-5'>{item.value}</p>
                  ) : (
                    <div className='mt-1'>{item.value}</div>
                  )}
                </div>
              ))}
              {paymentDetail.note && (
                <div className='col-span-1 md:col-span-2'>
                  <p className='text-sm text-gray-500 font-semibold mb-1'>Note</p>
                  <p className='text-base font-medium text-gray-5'>{paymentDetail.note}</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionHistory;
